import { render } from "./RegisterContent.vue?vue&type=template&id=01563c3e"
import script from "./RegisterContent.vue?vue&type=script&lang=js"
export * from "./RegisterContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__